var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"label":_vm.label,"disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }